{
  "pending": "En espera",
  "delivered": "Entregado",
  "retry": "Volver a intentar",
  "error": "Error",
  "cancelling": "Cancelación",
  "cancelled": "Anulado",
  "paused": "En pausa",
  "done": "Terminado",
  "running": "En curso",
  "expired": "Caducada",
  "dateFormat": "DD/MM/YYYY a HH:mm",
  "operationType": {
    "CRTCLT_RENEWAL_DVC": "Renovación de certificado",
    "CRTCLT_RENEWAL_APP": "Renovación de certificado",
    "FIRMWARE_UPGRADE_DVC": "Actualización del firmware"
  },
  "type": "Tipo de operación",
  "createdAt": "Fecha de creación",
  "launchedAt": "Fecha de activación prevista",
  "updatedAt": "Fecha de modificación",
  "state": "Estado de la operación",
  "certificate": {
    "update": {
      "label": "Renovación de certificado",
      "dateTimeError": "El campo de fecha es obligatorio para la actualización del certificado",
      "plannedStartAt": {
        "label": "Configurar la operación",
        "placeholder": "Seleccione una fecha de actualización"
      },
      "dateNotValidAfterRenewal": "La fecha debe ser válida antes de la caducidad del certificado"
    }
  },
  "firmware": {
    "update": {
      "label": "Actualización del firmware",
      "description": "Configurar la fecha y hora del procedimiento de activación de la actualización del firmware de {name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "El firmware es obligatorio",
      "plannedStartAt": "Fecha de actualización del firmware (DD/MM/YYYY HH:MM)",
      "notaBene": "La actualización del firmware se realizará durante la próxima comunicación con {name} a partir de la fecha de actualización del firmware.",
      "dateTimeError": "El campo de fecha es obligatorio para la actualización del firmware",
      "warningMessage": "Importante: actualizar el firmware implicará un reinicio del equipo al final de la actualización.",
      "version": "Versión",
      "dtwin": {
        "description": "Ajuste la configuración de la actualización del firmware.",
        "launchPlannedAt": "Fecha de actualización",
        "validation": {
          "launchPlannedAt": "La fecha de actualización es obligatoria."
        },
        "startsAtCreation": "Transmisión de la operación al equipo cuando sea posible",
        "firmware": "Seleccione un firmware en la siguiente lista"
      },
      "scheduled": {
        "warningMessage": "El equipo ya tiene una operación del mismo tipo planificada, en espera o en curso"
      }
    }
  },
  "dateInferiorToToday": "La fecha no debe ser anterior a la fecha/hora actual",
  "empty": "No se encontró ninguna operación",
  "actions": "Acciones",
  "queued": "En cola",
  "failed": "Error",
  "unknown": "Estado desconocido",
  "scheduled": "Programado",
  "configuration": {
    "selfSupportingVersion": "Versión autónoma",
    "globalVersion": "Versión global",
    "specificVersion": "Versión específica",
    "updatedDate": "Fecha actualizada"
  },
  "unitary": {
    "title": "Unitario"
  },
  "campaign": {
    "title": "Campaña"
  },
  "trigger": {
    "title": "Activación",
    "AUTO": "Automática",
    "MANUAL": "Manual"
  },
  "on_hold": "Retenido"
}
